// extracted by mini-css-extract-plugin
module.exports = {"container":"warning_container__sA7gv"};